import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Toaster } from 'sonner';
import { LogOut, Wheat } from 'lucide-react';
import ZakatRamadanManager from '../components/admin/ZakatRamadanManager';

export default function UPZDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Toaster position="top-right" richColors />

      {/* Header */}
      <div className="bg-gradient-to-r from-emerald-800 to-emerald-900 text-white sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center">
              <Wheat className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-base font-heading font-bold leading-tight">Dashboard UPZ Zakat Ramadan</h1>
              <p className="text-emerald-200 text-xs">masjidberdaya.id</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-emerald-100 hidden sm:block">{user?.name}</span>
            <button onClick={handleLogout} className="p-2 rounded-full hover:bg-white/10 transition-colors" title="Keluar">
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-5 py-7">
        <ZakatRamadanManager />
      </div>
    </div>
  );
}
